"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainTable = void 0;
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const alchemy_ui_1 = require("@m/alchemy-ui");
const modals_1 = require("@mdigital/components/dist/utils/modals");
const utils_1 = require("../../../common/utils");
const styled_1 = require("./styled");
const HorizontalStack_1 = __importDefault(require("@mdigital/components/dist/components/HorizontalStack"));
const TextPathPrefix = 'app.pages.administration.domainsList';
const Delete = `${TextPathPrefix}.delete`;
const Cancel = `${TextPathPrefix}.cancel`;
const Title = `${TextPathPrefix}.deleteDomain`;
const Subtitle = `${TextPathPrefix}.deleteWarning`;
const NoDomains = `${TextPathPrefix}.noDomainsFound`;
const DomainName = `${TextPathPrefix}.domainName`;
const LastModified = `${TextPathPrefix}.lastModified`;
const Actions = `${TextPathPrefix}.actions`;
const DomainTable = (props) => {
    const { domains } = props;
    const [currentSort, setCurrentSort] = (0, react_1.useState)('timestamp');
    const [sortDirection, setSortDirection] = (0, react_1.useState)('descending');
    const sortByName = (_, direction) => {
        setSortDirection(direction);
        setCurrentSort('name');
    };
    const sortByTimestamp = (_, direction) => {
        setSortDirection(direction);
        setCurrentSort('timestamp');
    };
    const sortDomains = (domains, direction, sort) => {
        const sortMultiplier = direction === 'descending' ? -1 : 1;
        if (sort === 'name') {
            return domains.sort((first, second) => first.domainName.localeCompare(second.domainName) * sortMultiplier);
        }
        else {
            return domains.sort((first, second) => (first.lastModifiedTimestamp - second.lastModifiedTimestamp) * sortMultiplier);
        }
    };
    const deleteDomain = (item) => {
        modals_1.ModalsService.showConfirmation({
            close: {
                title: (0, utils_1.getSingleText)(Cancel),
            },
            type: 'danger',
            confirm: {
                title: (0, utils_1.getSingleText)(Delete),
                callback: () => props.removeItem(item),
            },
            title: (0, utils_1.getSingleText)(Title),
            description: (0, utils_1.getSingleText)(Subtitle),
        });
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(alchemy_ui_1.Table, null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement(alchemy_ui_1.TableRow, null,
                    react_1.default.createElement(alchemy_ui_1.SortCell, { isHeader: true, onToggle: sortByName, sortDirection: currentSort === 'name' ? sortDirection : 'none', columnIndex: 1 }, (0, utils_1.getSingleText)(DomainName)),
                    react_1.default.createElement(alchemy_ui_1.SortCell, { onToggle: sortByTimestamp, isHeader: true, sortDirection: currentSort === 'timestamp' ? sortDirection : 'none', columnIndex: 2, style: { width: 400 } }, (0, utils_1.getSingleText)(LastModified)),
                    react_1.default.createElement(alchemy_ui_1.TableCell, { isHeader: true, style: { width: 120 } }, (0, utils_1.getSingleText)(Actions)))),
            !!domains.length &&
                react_1.default.createElement("tbody", null, sortDomains(domains, sortDirection, currentSort).map((item) => {
                    const date = new Date(item.lastModifiedTimestamp);
                    const formattedDate = (0, moment_1.default)(date).format('MMM DD, YYYY h:mm A');
                    return (react_1.default.createElement(alchemy_ui_1.TableRow, { shouldHighlightOnHover: true, key: item.lastModifiedTimestamp },
                        react_1.default.createElement(alchemy_ui_1.TableCell, null, item.domainName),
                        react_1.default.createElement(alchemy_ui_1.TableCell, null, formattedDate),
                        react_1.default.createElement(alchemy_ui_1.TableCell, null,
                            react_1.default.createElement(HorizontalStack_1.default, { gap: (0, alchemy_ui_1.units)(2) },
                                react_1.default.createElement(alchemy_ui_1.Tooltip, { trigger: react_1.default.createElement(alchemy_ui_1.IconButton, { palette: "expressiveNeutral", icon: react_1.default.createElement(alchemy_ui_1.EditIcon, { "aria-hidden": "true" }), onClick: () => props.editDomain(item) }), placement: "top", contents: "Edit" }),
                                react_1.default.createElement(alchemy_ui_1.Tooltip, { trigger: react_1.default.createElement(alchemy_ui_1.IconButton, { palette: "expressiveNeutral", icon: react_1.default.createElement(alchemy_ui_1.DeleteIcon, { "aria-hidden": "true" }), onClick: () => deleteDomain(item.lastModifiedTimestamp) }), placement: "top", contents: "Delete" })))));
                }))),
        !domains.length && react_1.default.createElement(styled_1.NoSearchResultBlock, null,
            react_1.default.createElement(alchemy_ui_1.NotFoundIcon, { size: "64", palette: 'expressiveNeutral', color: "highlight", "aria-hidden": "true" }),
            react_1.default.createElement(styled_1.NoDomainsText, null, (0, utils_1.getSingleText)(NoDomains)))));
};
exports.DomainTable = DomainTable;
